import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "workSchedule" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "flex min-w-0 flex-col md:col-span-12 lg:col-span-8" }
const _hoisted_4 = { class: "flex min-w-0 flex-col p-0 md:col-span-12 lg:col-span-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-[13px] font-extrabold text-red-600"
}
const _hoisted_6 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_7 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_9 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "m-0 text-[13px] font-medium text-slate-800" }
const _hoisted_13 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_14 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_15 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_16 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_17 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_18 = { class: "flex items-center gap-3 w-full" }
const _hoisted_19 = { class: "relative inline-flex w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar", true)!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Panel, { header: "Lịch trực (Click vào ô trong lịch để xem chi tiết)" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FullCalendar, {
                    options: $setup.calendarOptions,
                    class: "text-xs"
                  }, null, 8, ["options"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              ($setup.checkSelect)
                ? (_openBlock(), _createBlock(_component_Panel, {
                    key: 0,
                    header: $setup.dateString,
                    class: "h-full text-red-600"
                  }, {
                    default: _withCtx(() => [
                      ($setup.listSelect.length < 1)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_5, "**Chưa có lịch phân công**"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_Panel, {
                            header: "Thêm nhân viên trực",
                            class: "text-[13px]"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _cache[6] || (_cache[6] = _createElementVNode("label", null, "Chọn thành viên", -1)),
                                  _createVNode(_component_Dropdown, {
                                    modelValue: $setup.customer.idMember,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customer.idMember) = $event)),
                                    options: $setup.listCustomer,
                                    optionLabel: "name",
                                    optionValue: "idMember",
                                    filter: true,
                                    class: "text-[13px]"
                                  }, {
                                    option: _withCtx((slotProps) => [
                                      _createElementVNode("div", _hoisted_10, [
                                        (slotProps.option.imageUrl)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: slotProps.option.imageUrl,
                                              class: "mr-1 h-5 w-5 rounded object-cover"
                                            }, null, 8, _hoisted_11))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("label", _hoisted_12, _toDisplayString(slotProps.option.name), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _cache[7] || (_cache[7] = _createElementVNode("label", null, "Thêm", -1)),
                                  _createVNode(_component_Button, {
                                    label: "Thêm",
                                    icon: "pi pi-plus-circle",
                                    iconPos: "left",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addWorkSchedule($setup.customer.idMember))),
                                    class: "text-[13px]"
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_Panel, { header: "Danh sách nhân viên trực" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_DataTable, {
                                    value: $setup.listSelect,
                                    scrollable: "",
                                    showGridlines: "",
                                    stripedRows: "",
                                    rows: 10,
                                    rowsPerPageOptions: [10, 25, 50],
                                    rowHover: true,
                                    filters: $setup.filters,
                                    "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters) = $event)),
                                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                    globalFilterFields: ['fullName'],
                                    currentPageReportTemplate: "Có tổng số {totalRecords} thành viên",
                                    columnResizeMode: "fit | expand",
                                    tableclass: "text-[13px]"
                                  }, {
                                    header: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createVNode(_component_Button, {
                                            type: "button",
                                            icon: "pi pi-filter-slash",
                                            label: "Xoá lọc",
                                            outlined: "",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearFilter()))
                                          }),
                                          _createElementVNode("span", _hoisted_19, [
                                            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                                            _createVNode(_component_InputText, {
                                              class: "!pl-9 text-[13px] !w-full",
                                              modelValue: $setup.filters['global'].value,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters['global'].value) = $event)),
                                              placeholder: "Tìm theo tên hoặc số điện thoại"
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_Column, {
                                        field: "fullName",
                                        header: "Tên",
                                        sortable: ""
                                      }),
                                      _createVNode(_component_Column, { header: "Tuỳ chọn" }, {
                                        body: _withCtx((slotProps) => [
                                          _createVNode(_component_Button, {
                                            severity: "danger",
                                            label: "Xoá",
                                            icon: "pi pi-trash",
                                            onClick: ($event: any) => ($setup.deleteWorkSchedule(slotProps.data.id)),
                                            class: "max-w-[100px] text-[13px]"
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value", "filters"])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ConfirmDeleteModal, {
      modelValue: $setup.showConfirmModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.showConfirmModal) = $event)),
      title: $setup.confirmTitle,
      message: $setup.confirmMessage,
      "is-loading": $setup.isConfirming,
      onConfirm: $setup.confirmDelete.confirm,
      onCancel: $setup.confirmDelete.cancel
    }, null, 8, ["modelValue", "title", "message", "is-loading", "onConfirm", "onCancel"])
  ], 64))
}